export const MonthAsByDate = (dateString: string) => {
	const date = new Date(dateString);
	const monthNames = [
		'JAN',
		'FEB',
		'MAR',
		'APR',
		'MEI',
		'JUN',
		'JUL',
		'AGS',
		'SEP',
		'OKT',
		'NOV',
		'DES',
	];
	const monthIndex = date.getMonth();
	const monthString = monthNames[monthIndex];

	return monthString;
};

export const formatDuration = (seconds: number) => {
	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = seconds % 60;

	const formattedHours = String(hours).padStart(2, '0');
	const formattedMinutes = String(minutes).padStart(2, '0');
	const formattedSeconds = String(remainingSeconds).padStart(2, '0');

	return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const convertToInputDate = (dateString: string) => {
	// Create a new Date object using the provided string
	let date = new Date(dateString);

	// Extract the date part
	let year = date.getFullYear();
	let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
	let day = String(date.getDate()).padStart(2, '0');

	// Construct the date string in the format YYYY-MM-DD
	return `${year}-${month}-${day}`;
};
